import { render, staticRenderFns } from "./system-setup.vue?vue&type=template&id=37efe47e&"
import script from "./system-setup.vue?vue&type=script&lang=js&"
export * from "./system-setup.vue?vue&type=script&lang=js&"
import style0 from "./system-setup.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports